import { apiGet, apiPost, ApiCallError } from "./client.js";

export interface PipelineExecutionSummary {
  id: string;
  websiteId: string;
  userId: string;
  status: string;
  startedAt: string;
  completedAt: string | null;
  stages: Array<{
    stage: string;
    runId: string;
    status: string;
    startedAt: string;
    completedAt: string | null;
  }>;
}

export function triggerPipelineRun(
  websiteId: string,
): Promise<{ ok: boolean; jobId: string; executionId: string }> {
  return apiPost(`/websites/${websiteId}/pipeline/run`, {});
}

export async function getLatestExecution(
  websiteId: string,
): Promise<PipelineExecutionSummary | null> {
  try {
    return await apiGet<PipelineExecutionSummary>(
      `/websites/${websiteId}/pipeline/latest`,
    );
  } catch (err) {
    if (err instanceof ApiCallError && err.status === 404) return null;
    throw err;
  }
}

export function cancelPipelineRun(
  websiteId: string,
): Promise<{ ok: boolean; cancelledExecutions: number; cancelledJobs: number }> {
  return apiPost(`/websites/${websiteId}/pipeline/cancel`, {});
}
